import React, { useState } from 'react';
import { getVendorAvailability } from '@/services/api/vendors';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { translations } from '@/locale';
import Modal from '@/components/Modal';
import TimeOffModal from '@/components/Modal/TimeOffModal';
import LoadData from '@/components/LoadData';
import Loading from '@/components/Loading';
import If from '@/components/If';
import Placeholder from '@/components/Placeholder';
import { VendorAvailability } from '@/domains/availability';
import Grid from '@/components/Grid';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';

export interface Props {
  id: string;
}

const VendorAvailabilityTab: React.FC<Props> = ({ id }) => {
  const [availability, setAvailability] = useState<VendorAvailability>();

  return (
    <LoadData id={id} load={getVendorAvailability}>
      {({ value: availability, loading, reload }) => (
        <If
          condition={loading}
          then={() => <Loading visible={true} />}
          else={() => (
            <If
              condition={!availability}
              then={() => (
                <Placeholder
                  className="h-full justify-center"
                  image="bell"
                  size="xs"
                  title="Oups"
                  description="Vendor not found. Please try again later."
                />
              )}
              else={() => {
                return (
                  <React.Fragment>
                    <Grid>
                      <div className="flex justify-between">
                        <div>
                          <h2 id="payment-details-heading" className="text-lg leading-6 font-medium text-gray-900">
                            Scheduled time off
                          </h2>
                          <p className="mt-1 text-sm text-gray-500">
                            {"Add scheduled breaks when the vendor doesn't take orders."}
                          </p>
                        </div>

                        <Modal modal={TimeOffModal} vendorId={id} onSaved={reload}>
                          {({ open }) => (
                            <Button variant="outline" className="mt-4" onClick={open}>
                              Add time off
                            </Button>
                          )}
                        </Modal>
                      </div>

                      <Table>
                        <TableBody>
                          {availability.breaks.map((e) => {
                            return (
                              <TableRow key={e.id}>
                                <TableCell>
                                  <span>
                                    <FormattedDate value={e.startDate} day="2-digit" month="long" year="numeric" />{' '}
                                    {' - '}
                                    <FormattedDate value={e.endDate} day="2-digit" month="long" year="numeric" />
                                  </span>
                                </TableCell>
                                <TableCell>
                                  <Button className="ml-4" variant="destructive">
                                    Delete
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Grid>
                  </React.Fragment>
                );
              }}
            />
          )}
        />
      )}
    </LoadData>
  );
};

export default VendorAvailabilityTab;
